import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Project, Role } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  role: Identifiable<Role>;
  retrieveProjectRole(
    request: Boundaries["retrieveProjectRole"]["request"],
  ): void;
}

function useRetrieveProjectRole(project: Identifiable<Project>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveProjectRoleRequestPending(project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveProjectRoleRequestSuccess(project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveProjectRoleRequestFailure(project),
    ),
    role: useSelector(() => selector.getProjectRole(project)),
    retrieveProjectRole: core.retrieveProjectRole,
  };
}

export { useRetrieveProjectRole };
